import { 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
    Box,
    Typography,
    Chip,
    Stack,
    IconButton
} from "@mui/material";
import { Publish, Close, NotificationsActive, Visibility } from "@mui/icons-material";

interface ConfirmBankAccountDialogProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onProceed: () => void;
}

export default function ConfirmBankAccountDialog({ open, setOpen, onProceed }: ConfirmBankAccountDialogProps) {
    const handleClose = () => setOpen(false);

    const handleProceed = () => {
        setOpen(false);
        onProceed();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="confirm-bank-account-dialog-title"
            aria-describedby="confirm-bank-account-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                    overflow: 'visible'
                }
            }}
        >
            <DialogTitle id="first-resource-publish-dialog-title" sx={{ fontWeight: 'bold' }} >
                Confirm Payout Details
            </DialogTitle>

            <DialogContent>
                <DialogContentText 
                    id="confirm-bank-account-dialog-description"
                    sx={{ 
                        color: 'text.secondary',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                    }}
                >
                    Are you sure your bank details are correct, changing this in the future
                    requires contacting our support.
                </DialogContentText>
            </DialogContent>


            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    onClick={handleClose}
                    variant="outlined"
                    sx={{ 
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 500,
                        px: 3,
                        py: 1,
                        borderColor: '#d1d5db',
                        color: '#6b7280',
                        '&:hover': {
                            borderColor: '#9ca3af',
                            backgroundColor: '#f9fafb'
                        }
                    }}
                >
                    Cancel
                </Button>

                <Button
                    onClick={handleProceed}
                    variant="contained"
                    sx={{ 
                        backgroundColor: "#10b981",
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 4,
                        py: 1,
                        boxShadow: '0 4px 12px -2px rgba(16, 185, 129, 0.3)',
                        '&:hover': {
                            backgroundColor: "#059669",
                            boxShadow: '0 8px 20px -4px rgba(16, 185, 129, 0.4)',
                            transform: 'translateY(-1px)'
                        },
                        transition: 'all 0.2s ease'
                    }}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}